import type { BlogPost } from './types';
import bestRecipeApps from './posts/best-recipe-apps';
import saveMealimeRecipes from './posts/save-mealime-recipes';

/**
 * Every published post, newest first. Add a post by creating a module under
 * `posts/` and listing it here; the index page, the sitemap and the static
 * prerender all read from this list.
 */
export const posts: BlogPost[] = [bestRecipeApps, saveMealimeRecipes].sort(
  (a, b) => +new Date(b.publishedAt) - +new Date(a.publishedAt),
);

export const getPost = (slug: string): BlogPost | undefined => posts.find((p) => p.slug === slug);

export type { BlogPost } from './types';
